import { store } from '../../store'

export const deleteQuizTopic = async ( id: number ) => {

    let response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/quizes/topics/${ id }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'DELETE'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'DELETE_QUIZ_TOPIC_TIMEOUT' } )
        return

    }

    if ( response.status === 500 ) {

        store.dispatch( { type: 'DELETE_QUIZ_TOPIC_ERROR' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'DELETE_QUIZ_TOPIC_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'DELETE_QUIZ_TOPIC_UNEXPECTEDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'DELETE_QUIZ_TOPIC_OK' } )

}